// An organization id rides one segment of the document's address, so it can
// hold no separator, query, fragment or escape character, and cannot be a dot
// segment, which a URL resolves to this or the parent directory.
export const isOrganizationId = (id: string): boolean =>
	/^[^/\\?#%]+$/.test(id) && id !== "." && id !== ".." && id.length <= 1500;
